import WeddingEventFeatureUpsell from './WeddingEventFeatureUpsell';
import WeddingEventFeatureUpsellModal, {
  WEDDING_EVENT_FEATURE_UPSELL_MODAL,
} from './modal';

export { WEDDING_EVENT_FEATURE_UPSELL_MODAL, WeddingEventFeatureUpsellModal };

export default WeddingEventFeatureUpsell;
